import Vue from "vue";
import App from "./App";
import router from "./router/index";

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import BootstrapVue from "bootstrap-vue";
import VueToastify from 'vue-toastify'

Vue.config.productionTip = false;

Vue.use(PaperDashboard);
Vue.use(BootstrapVue);
Vue.use(VueToastify);

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
